import { Pipe, PipeTransform, inject } from '@angular/core';
import { PermissionService } from './permission.service';
import { Action } from './permission.model';

@Pipe({ name: 'can', pure: false, standalone: false })
export class CanPipe implements PipeTransform {
  private permissionService = inject(PermissionService);


  transform(action: Action): boolean {
    return this.permissionService.can(action);
  }
}
